import Vue from 'vue'
import Router from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 通用任务列表组件（嵌字 & 翻译共用）
import TaskList from '@/components/TaskList'
import MsgBox from '@/components/msgbox'
import HistoryBox from '@/components/history'

Vue.use(ElementUI)
Vue.use(Router)

export default new Router({
  routes: [
    // 翻译任务列表（默认首页）
    {
      path: '/',
      redirect: '/fy'
    },
    {
      path: '/index',
      redirect: '/fy'
    },
    // 翻译任务列表
    {
      path: '/fy',
      name: 'fy',
      component: TaskList,
      props: { type: 'fy' }
    },
    // 留言板
    {
      path: '/msgbox',
      name: 'msgbox',
      component: MsgBox
    },
    // 历史记录（待完成）
    {
      path: '/history',
      name: 'history',
      component: HistoryBox
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js